import { convertReactAdminIdToHydraId } from 'utils/convertReactAdminIdToHydraId';

export const mapToHydraIds = (ids?: string[], resource: string = ''): string[] =>
  ids?.map((id) => convertReactAdminIdToHydraId(id, resource)) || [];
